// extracted by mini-css-extract-plugin
export default {"main":"MyLessons_main__UgPnI","link":"MyLessons_link__xVkGz","content":"MyLessons_content__YA0Lq","filterButtonsBlock":"MyLessons_filterButtonsBlock__YovbI"};